import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { requestService } from '../services/requestService'
import type { CatalogData } from '../types'

interface UseCatalogResult {
  catalog: CatalogData | null
  loading: boolean
  error: string | null
}

export function useCatalog(): UseCatalogResult {
  const [catalog, setCatalog] = useState<CatalogData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    requestService
      .getCatalog()
      .then(setCatalog)
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load catalog'))
      )
      .finally(() => setLoading(false))
  }, [])

  return { catalog, loading, error }
}
